<template>
  <div class="container-xxl flex-grow-1 container-p-y">
    <div
      class="modal fade"
      id="cards-groups-columns"
      tabindex="-1"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-xl modal-dialog-centered modal-simple modal-upgrade-plan"
      >
        <div class="modal-content">
          <div class="modal-body">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>

            <div class="text-center">
              <h4 class="mb-2">{{ $t("batches.cards_groups_columns") }}</h4>
            </div>

            <div class="card-body">
              <div class="row">
                <div class="col-xxl-3 col-md-4 col-6 mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="Profile"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-cards"></i>
                        <span class="custom-option-title">
                          {{ $t("batches.name") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        v-model="columns.name.enabled"
                        @change="updateColumns"
                        type="checkbox"
                        id="Profile"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="firstname"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-michelin-star"></i>
                        <span class="custom-option-title">
                          {{ $t("batches.quantity") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        v-model="columns.quantity.enabled"
                        @change="updateColumns"
                        type="checkbox"
                        id="firstname"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="lastname"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-square-off"></i>
                        <span class="custom-option-title">
                          {{ $t("batches.not_used_cards") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        v-model="columns.fresh_cards.enabled"
                        @change="updateColumns"
                        type="checkbox"
                        id="lastname"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="Price"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-tags"></i>
                        <span class="custom-option-title">
                          {{ $t("batches.price") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        v-model="columns.price.enabled"
                        @change="updateColumns"
                        type="checkbox"
                        id="Price"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="prefix"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-caret-left"></i>
                        <span class="custom-option-title">
                          {{ $t("batches.prefix") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        v-model="columns.prefix.enabled"
                        @change="updateColumns"
                        type="checkbox"
                        id="prefix"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6 mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="lineNumber"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-brand-databricks"></i>
                        <span class="custom-option-title">
                          {{ $t("batches.profile") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        v-model="columns.profile.enabled"
                        @change="updateColumns"
                        type="checkbox"
                        id="lineNumber"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="portNumber"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-ruler-measure"></i>
                        <span class="custom-option-title">
                          {{ $t("batches.username_length") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        v-model="columns.username_length.enabled"
                        @change="updateColumns"
                        type="checkbox"
                        id="portNumber"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="Notes"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-password"></i>
                        <span class="custom-option-title">
                          {{ $t("batches.password_length") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        v-model="columns.password_length.enabled"
                        @change="updateColumns"
                        type="checkbox"
                        id="Notes"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="ip"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-versions"></i>
                        <span class="custom-option-title">
                          {{ $t("batches.allowed_sessions") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="columns.allowed_sessions.enabled"
                        @change="updateColumns"
                        id="ip"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="expirationDate"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-password-mobile-phone"></i>
                        <span class="custom-option-title">
                          {{ $t("batches.allow_only_one_mac_address") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        v-model="columns.is_mac.enabled"
                        @change="updateColumns"
                        type="checkbox"
                        id="expirationDate"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6 mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="ASessions"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-calendar-plus"></i>
                        <span class="custom-option-title">
                          {{ $t("control.created_at") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        v-model="columns.created_at.enabled"
                        @change="updateColumns"
                        type="checkbox"
                        id="ASessions"
                      />
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <cardsAdd
      v-if="hasPrivilege('cards_edit_cards') && showAddBatch"
      @updated="applyFilters"
      :copyCard="copyCard"
    />

    <ProfileAdd
      v-if="showAddProfile && hasPrivilege('profiles_edit_profiles')"
      :visible="showAddProfile"
      @updated="
        $router.push({ query: {} });
        applyFilters();
      "
    />

    <div class="card">
      <div class="card-datatable">
        <div class="dataTables_wrapper dt-bootstrap5 no-footer">
          <div class="row mx-1" bis_skin_checked="1">
            <div
              class="col-12 col-md-4 d-flex align-items-center justify-content-center justify-content-md-start gap-2 mt-6 mt-md-0 mt-lg-0 mt-xl-0 mt-xxl-0"
              bis_skin_checked="1"
            >
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div
                  class="dt-buttons btn-group flex-wrap"
                  bis_skin_checked="1"
                >
                  <button
                    class="btn btn-primary waves-effect waves-light"
                    type="button"
                    @click.prevent="showAddBatchDialog"
                    v-if="hasPrivilege('cards_edit_cards')"
                  >
                    <span>
                      <i class="ti ti-plus ti-xs me-2"></i>
                      <span class=" ">{{ $t("batches.generate_cards") }}</span>
                    </span>
                  </button>
                </div>
              </div>
            </div>
            <div
              class="col-12 col-md-8 d-flex align-items-center justify-content-end flex-column flex-md-row pe-5 gap-2 gap-md-4 mt-4  mt-md-0"
              bis_skin_checked="1"
            >
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div class="btn-group" id="dropdown-icon-demo">
                  <button
                    v-if="hasPrivilege('reports_print')"
                    :disabled:="!this.$store.getters.settings.license.active"
                    type="button"
                    class="btn btn-info dropdown-toggle"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i class="ti ti-upload ti-xs me-2"></i>
                    {{ $t("control.export") }}
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <a
                        href="javascript:void(0);"
                        @click.prevent="print_table('groups_table')"
                        class="dropdown-item d-flex align-items-center"
                        ><i class="ti ti-printer me-2"></i
                        >{{ $t("control.print") }}</a
                      >
                    </li>
                    <li>
                      <a
                        @click.prevent="
                          export_csv('groups_table', 'cards_groups')
                        "
                        href="javascript:void(0);"
                        class="dropdown-item d-flex align-items-center"
                        ><i class="ti ti-file me-2"></i
                        >{{ $t("control.csv") }}</a
                      >
                    </li>
                    <li>
                      <a
                        href="javascript:void(0);"
                        @click.prevent="
                          export_pdf('groups_table', 'cards_groups')
                        "
                        class="dropdown-item d-flex align-items-center"
                        ><i class="ti ti-file-text me-2"></i
                        >{{ $t("control.pdf") }}</a
                      >
                    </li>
                  </ul>
                </div>
              </div>

              <div
                id="DataTables_Table_0_filter"
                class="dataTables_filter"
                bis_skin_checked="1"
              >
                <label>
                  <input
                    type="search"
                    class="form-control"
                    @change="applyFilters"
                    :placeholder="$t('control.search')"
                    v-model="filters.search_query"
                    v-if="hasPrivilege('cards_view_search_batches')"
                    aria-controls="DataTables_Table_0"
                  />
                </label>
              </div>
            </div>
          </div>
          <div class="row mx-1 mt-n6" bis_skin_checked="1">
            <div
              class="col-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start gap-2"
              bis_skin_checked="1"
            >
              <div
                class="dataTables_length"
                id="DataTables_Table_0_length"
                bis_skin_checked="1"
              >
                <label
                  >{{ $t("control.show") }}
                  <select
                    v-model="filters.rows"
                    @change="applyFilters"
                    name="DataTables_Table_0_length"
                    aria-controls="DataTables_Table_0"
                    class="form-select"
                  >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="500">500</option>
                    <option value="9999999">{{
                      $t("control.rows_all")
                    }}</option>
                  </select>
                </label>
              </div>
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div
                  class="dt-buttons btn-group flex-wrap"
                  bis_skin_checked="1"
                >
                  <button
                    data-bs-toggle="modal"
                    data-bs-target="#cards-groups-columns"
                    class="btn btn-secondary  waves-effect waves-light"
                    tabindex="0"
                    aria-controls="DataTables_Table_0"
                    type="button"
                  >
                    <span>
                      <i class="ti ti-scan-eye ti-s me-md-2"></i>
                      <span class="d-md-inline-block d-none">{{
                        $t("control.columns_visible")
                      }}</span>
                    </span>
                  </button>
                </div>
              </div>
              <div
                v-if="selection_array.length == 1"
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div
                  class="dt-buttons btn-group flex-wrap"
                  bis_skin_checked="1"
                >
                  <button
                    @click.prevent="
                      this.$router.push({
                        name: 'CardsDesign',
                        params: { id: selection_array[0].id },
                      })
                    "
                    class="btn btn-primary  waves-effect waves-light"
                    tabindex="0"
                    type="button"
                  >
                    <span>
                      <i class="ti ti-printer ti-s me-md-2"></i>
                      <span class="d-md-inline-block d-none">{{
                        $t("batches.print_cards")
                      }}</span>
                    </span>
                  </button>
                </div>
              </div>
            </div>

            <div
              class="col-12 col-md-1 d-flex align-items-center justify-content-center justify-content-md-start gap-2 mt-n6 mt-md-0"
              bis_skin_checked="1"
            ></div>

            <div
              class="col-12 col-md-6 d-flex align-items-center justify-content-end flex-column flex-md-row pe-5 gap-2 gap-md-4 mt-n2 mb-6 mb-md-0 mt-md-0"
              bis_skin_checked="1"
            >
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div
                  class="dt-buttons btn-group flex-wrap"
                  bis_skin_checked="1"
                >
                  <button
                    :class="{
                      'btn-primary': autoUpdate,
                      'btn-secondary': !autoUpdate,
                    }"
                    @click.prevent="toggleAutoUpdate"
                    class="btn waves-effect waves-light"
                    tabindex="0"
                    aria-controls="DataTables_Table_0"
                    type="button"
                  >
                    <span>
                      <i class="ti ti-refresh ti-s me-2"></i>
                      <span class=" ">{{ $t("control.auto_update") }}</span>
                    </span>
                  </button>
                </div>
              </div>
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div
                  class="dt-buttons btn-group flex-wrap"
                  bis_skin_checked="1"
                >
                  <button
                    :class="{
                      'btn-primary': filters.save,
                      'btn-secondary': !filters.save,
                    }"
                    @click.prevent="toggleSaveFilters"
                    class="btn waves-effect waves-light"
                    tabindex="0"
                    aria-controls="DataTables_Table_0"
                    type="button"
                  >
                    <span>
                      <i class="ti ti-filter-check ti-s me-2"></i>
                      <span class=" ">{{ $t("control.save_filters") }}</span>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="dataTables_scroll" bis_skin_checked="1">
            <div
              class="dataTables_scrollBody table-container"
              bis_skin_checked="1"
              style="position: relative; overflow: auto; width: 100%; height: 480px;"
            >
              <table
                class="dt-scrollableTable table"
                id="groups_table"
                aria-describedby="DataTables_Table_0_info"
              >
                <thead
                  style="background-color: var(--bs-card-bg);"
                  class="sticky top-0 z-50"
                >
                  <tr class="text-nowrap">
                    <th>
                      <div class="dropdown" v-if="selection_array.length > 1">
                        <button
                          type="button"
                          class="btn p-0 dropdown-toggle hide-arrow"
                          data-bs-toggle="dropdown"
                        >
                          <i class="ti ti-dots-vertical"></i>
                        </button>
                        <ul class="dropdown-menu"></ul>
                      </div>
                    </th>
                    <th>
                      <!-- <input
                        class="form-check-input"
                        type="checkbox"
                        :value="allSelected"
                        @click="checkAll"
                      /> -->
                    </th>
                    <th class="sorting" v-if="columns.name.enabled">
                      {{ $t("batches.name") }}
                    </th>
                    <th class="sorting" v-if="columns.quantity.enabled">
                      {{ $t("batches.quantity") }}
                    </th>
                    <th class="sorting" v-if="columns.fresh_cards.enabled">
                      {{ $t("batches.not_used_cards") }}
                    </th>
                    <th class="sorting" v-if="columns.price.enabled">
                      {{ $t("batches.price") }}
                    </th>
                    <th class="sorting" v-if="columns.prefix.enabled">
                      {{ $t("batches.prefix") }}
                    </th>
                    <th class="sorting" v-if="columns.profile.enabled">
                      {{ $t("batches.profile") }}
                    </th>
                    <th class="sorting" v-if="columns.username_length.enabled">
                      {{ $t("batches.username_length") }}
                    </th>
                    <th class="sorting" v-if="columns.password_length.enabled">
                      {{ $t("batches.password_length") }}
                    </th>
                    <th class="sorting" v-if="columns.allowed_sessions.enabled">
                      {{ $t("batches.allowed_sessions") }}
                    </th>
                    <th class="sorting" v-if="columns.is_mac.enabled">
                      {{ $t("batches.allow_only_one_mac_address") }}
                    </th>
                    <th class="sorting" v-if="columns.created_at.enabled">
                      {{ $t("control.created_at") }}
                    </th>
                  </tr>
                  <tr v-if="hasPrivilege('cards_view_search_batches')">
                    <th></th>
                    <th></th>
                    <th
                      v-if="columns.name.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <input
                        @change="applyFilters"
                        v-model="filters.name"
                        type="text"
                        class="form-control"
                        :placeholder="$t('control.search')"
                      />
                    </th>
                    <th
                      v-if="columns.quantity.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <input
                        @change="applyFilters"
                        v-model="filters.quantity"
                        type="text"
                        class="form-control"
                        :placeholder="$t('control.search')"
                      />
                    </th>
                    <th v-if="columns.fresh_cards.enabled"></th>
                    <th
                      v-if="columns.price.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <input
                        @change="applyFilters"
                        v-model="filters.price"
                        type="text"
                        class="form-control"
                        :placeholder="$t('control.search')"
                      />
                    </th>
                    <th
                      v-if="columns.prefix.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <input
                        @change="applyFilters"
                        v-model="filters.prefix"
                        type="text"
                        class="form-control"
                        :placeholder="$t('control.search')"
                      />
                    </th>
                    <th
                      v-if="columns.profile.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <input
                        @change="applyFilters"
                        v-model="filters.profile"
                        type="text"
                        class="form-control"
                        :placeholder="$t('control.search')"
                      />
                    </th>
                    <th
                      v-if="columns.username_length.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <input
                        @change="applyFilters"
                        v-model="filters.username_length"
                        type="text"
                        class="form-control"
                        :placeholder="$t('control.search')"
                      />
                    </th>
                    <th
                      v-if="columns.password_length.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <input
                        @change="applyFilters"
                        v-model="filters.password_length"
                        type="text"
                        class="form-control"
                        :placeholder="$t('control.search')"
                      />
                    </th>
                    <th
                      v-if="columns.allowed_sessions.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <input
                        @change="applyFilters"
                        v-model="filters.allowed_sessions"
                        type="text"
                        class="form-control"
                        :placeholder="$t('control.search')"
                      />
                    </th>
                    <th v-if="columns.is_mac.enabled"></th>

                    <th
                      v-if="columns.created_at.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <input
                        @change="applyFilters"
                        v-model="filters.quantity"
                        type="datetime-local"
                        class="form-control"
                        placeholder="YYYY-MM-DD"
                        id="flatpickr-datetime"
                      />
                    </th>
                  </tr>
                </thead>
                <tbody v-if="loading" class="table-border-bottom-0 ">
                  <tr v-for="(item, index) in 10" :key="index">
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th
                      v-for="(item, index) in Object.values(columns).filter(
                        (col) => col?.enabled === true
                      ).length"
                      :key="index"
                    >
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                  </tr>
                </tbody>
                <tbody class="table-border-bottom-0 " v-if="!loading">
                  <tr v-for="(batch, index) in dataList" :key="batch.id">
                    <th>
                      <div class="dropdown" v-if="selection_array.length <= 1">
                        <button
                          type="button"
                          class="btn p-0 dropdown-toggle hide-arrow"
                          data-bs-toggle="dropdown"
                        >
                          <i class="ti ti-dots-vertical"></i>
                        </button>
                        <ul
                          class="dropdown-menu"
                          :class="{
                            disabled_ssr: !this.$store.getters.settings.license
                              .active,
                          }"
                        >
                          <li
                            v-if="hasPrivilege('accounts_view_index_accounts')"
                          >
                            <button
                              class="dropdown-item text-primary"
                              @click.prevent="
                                this.$router.push({
                                  name: 'GroupCards',
                                  params: { id: batch.id },
                                })
                              "
                            >
                              <i class="ti ti-eye me-2"></i
                              >{{ $t("actions.view") }}
                            </button>
                          </li>
                          <li
                            v-if="hasPrivilege('accounts_view_index_accounts')"
                          >
                            <button
                              class="dropdown-item text-primary"
                              @click.prevent="showAddBatchDialog(batch, 'copy')"
                            >
                              <i class="ti ti-clipboard me-2"></i
                              >{{ $t("actions.copy") }}
                            </button>
                          </li>
                          <li>
                            <button
                              @click.prevent="
                                this.$router.push({
                                  name: 'CardsDesign',
                                  params: { id: batch.id },
                                })
                              "
                              class="dropdown-item text-success"
                              href="#"
                            >
                              <i class="ti ti-printer me-2"></i
                              >{{ $t("actions.print") }}
                            </button>
                          </li>
                          <li>
                            <button
                              @click="exportCsv(batch.id)"
                              class="dropdown-item text-success"
                              href="#"
                            >
                              <i class="ti ti-printer me-2"></i
                              >{{ $t("actions.export_csv") }}
                            </button>
                          </li>

                          <li v-if="hasPrivilege('cards_delete_cards')">
                            <button
                              @click="showDeleteDialog(batch)"
                              class="dropdown-item text-danger"
                              href="#"
                            >
                              <i class="ti ti-trash me-2"></i
                              >{{ $t("actions.delete") }}
                            </button>
                          </li>
                        </ul>
                      </div>
                    </th>
                    <td scope="row">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="batch.selected"
                        @click="selectData(batch)"
                      />
                    </td>
                    <td v-if="columns.name.enabled">
                      <a
                        @click.prevent="
                          $router.push(`/cards/groups/${batch.id}`)
                        "
                        :href="`/cards/groups/${batch.id}`"
                      >
                        {{ batch.name }}
                      </a>
                    </td>
                    <td v-if="columns.quantity.enabled">
                      <span class="badge bg-label-primary me-1">{{
                        batch.quantity
                      }}</span>
                    </td>
                    <td v-if="columns.fresh_cards.enabled">
                      {{ batch.fresh_cards }}
                    </td>
                    <td v-if="columns.price.enabled">{{ batch.price }}</td>
                    <td v-if="columns.prefix.enabled">{{ batch.prefix }}</td>
                    <td v-if="columns.profile.enabled" scope="row">
                      <a
                        v-if="hasPrivilege('profiles_edit_profiles')"
                        :href="`profiles?profile_id=${batch.profile?.id}`"
                        @click.prevent="openAddProfileDialog(batch.profile)"
                        >{{ batch.profile?.name }}</a
                      >
                      <div v-else>
                        {{ batch.profile ? batch.profile.name : "" }}
                      </div>
                    </td>
                    <td v-if="columns.username_length.enabled">
                      {{ batch.username_length }}
                    </td>
                    <td v-if="columns.password_length.enabled">
                      {{ batch.password_length }}
                    </td>
                    <td v-if="columns.allowed_sessions.enabled">
                      {{ batch.allowed_sessions }}
                    </td>
                    <td v-if="columns.is_mac.enabled">
                      {{ batch.is_mac ? $t("control.yes") : $t("control.no") }}
                    </td>
                    <td v-if="columns.created_at.enabled">
                      {{ formatDate(batch.created_at) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="row mx-1" bis_skin_checked="1">
            <div class="col-sm-12 col-md-6" bis_skin_checked="1">
              <div
                class="dataTables_info"
                id="DataTables_Table_0_info"
                role="status"
                aria-live="polite"
                bis_skin_checked="1"
              >
                {{
                  $t("control.pagination", {
                    from: meta.from,
                    to: meta.to,
                    total: meta.total,
                  })
                }}
              </div>
            </div>

            <div class="col-sm-12 col-md-6" bis_skin_checked="1">
              <div
                class="dataTables_paginate paging_simple_numbers"
                id="DataTables_Table_0_paginate"
                bis_skin_checked="1"
              >
                <ul class="pagination">
                  <li
                    :class="{ disabled: filters.page < 2 }"
                    class="paginate_button page-item previous"
                    id="DataTables_Table_0_previous"
                  >
                    <a
                      @click.prevent="
                        filters.page = filters.page - 1;
                        applyFilters;
                      "
                      aria-controls="DataTables_Table_0"
                      aria-disabled="true"
                      role="link"
                      data-dt-idx="previous"
                      tabindex="-1"
                      class="page-link"
                    >
                      <i class="ti ti-chevron-left ti-sm"></i>
                    </a>
                  </li>
                  <li
                    class="paginate_button page-item"
                    :class="{
                      active: link.label == filters.page,
                      disabled: link.url == null,
                    }"
                    v-for="(link, index) in meta.links"
                    :key="index"
                  >
                    <a
                      v-if="index != 0 && index < meta.links.length - 1"
                      @click.prevent="
                        filters.page = link.label;
                        applyFilters();
                      "
                      href="#"
                      aria-controls="DataTables_Table_0"
                      role="link"
                      aria-current="page"
                      data-dt-idx="0"
                      tabindex="0"
                      class="page-link"
                      >{{ link.label }}</a
                    >
                  </li>
                  <li
                    :class="{
                      disabled: meta.current_page == meta.last_page,
                    }"
                    class="paginate_button page-item next"
                    id="DataTables_Table_0_next"
                  >
                    <a
                      href="#"
                      aria-controls="DataTables_Table_0"
                      role="link"
                      data-dt-idx="next"
                      tabindex="0"
                      class="page-link"
                    >
                      <i class="ti ti-chevron-right ti-sm"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import cardsAdd from "../components/modals/cards-add.vue";
import { mapGetters } from "vuex";
import {
  export_csv,
  export_pdf,
  hasPrivilege,
  print_table,
} from "../global_constants.js";
import ProfileAdd from "../components/modals/profile-add.vue";
export default {
  components: {
    cardsAdd,
    ProfileAdd,
  },
  computed: {
    ...mapGetters(["user"]),
  },
  name: "CardsGroups",
  data() {
    return {
      dataList: null,
      meta: { last_page: 0 },
      selectedData: null,
      showDetails: false,
      showDelete: false,
      showContext: false,
      showAddProfile: false,
      loading: true,
      showFilters: false,
      fullList: false,
      showAddBatch: false,
      filters: {
        rows: 50,
        page: "",
        save: false,
        name: "",
        quantity: "",
        price: "",
        prefix: "",
        profile: "",
        username_length: "",
        password_length: "",
        allowed_sessions: "",
        created_at: "",
        search_query: null,
      },
      copyCard: null,
      checkedBox: true,
      allSelected: false,
      showColumnsSelect: false,
      columns: {
        name: { name: this.$t("batches.name"), enabled: true },
        quantity: { name: this.$t("batches.quantity"), enabled: false },
        fresh_cards: { name: this.$t("batches.fresh_cards"), enabled: false },
        price: { name: this.$t("batches.price"), enabled: false },
        prefix: { name: this.$t("batches.prefix"), enabled: false },
        profile: { name: this.$t("batches.profile"), enabled: true },
        username_length: {
          name: this.$t("batches.username_length"),
          enabled: false,
        },
        password_length: {
          name: this.$t("batches.password_length"),
          enabled: false,
        },
        allowed_sessions: { name: this.$t("batches.sessions"), enabled: false },
        is_mac: { name: this.$t("batches.is_mac"), enabled: false },
        created_at: { name: this.$t("batches.created_at"), enabled: true },
      },
      autoUpdate: false,
      selection_array: [],
      debounce: null,
    };
  },
  async created() {
    if (this.$route.query.name) {
      this.filters.name = this.$route.query.name;
    }
    this.prepareFilters();
    this.applyFilters();
    this.prepareColumns();
  },
  methods: {
    hasPrivilege(privilege) {
      return hasPrivilege(this.user, privilege);
    },
    async fetchData() {
      if (this.filters.rows > 0 || this.filters.page > 0) {
        this.fetchDataPortion(this.filters.rows, this.filters.page);
        this.selection_array = [];
        return;
      }
      const response = await axios.get("cards");
      this.dataList = response.data.data;
      this.meta = response.data.meta;
      this.loading = false;
    },
    prepareFilters() {
      var filters = localStorage.getItem("batches_filters");
      if (filters != null) {
        filters = JSON.parse(filters);
        if (filters.save) this.filters = filters;
        else this.filters.rows = filters.rows;
      }
    },
    prepareColumns() {
      var cols = localStorage.getItem("batches_columns");
      if (cols != null) {
        cols = JSON.parse(cols);
        this.columns = {
          name: {
            name: this.$t("batches.name"),
            enabled: cols[0].enabled,
            sort: false,
          },
          quantity: {
            name: this.$t("batches.quantity"),
            enabled: cols[1].enabled,
            sort: false,
          },
          fresh_cards: {
            name: this.$t("batches.fresh_cards"),
            enabled: cols[2].enabled,
            sort: false,
          },
          price: {
            name: this.$t("batches.price"),
            enabled: cols[3].enabled,
            sort: false,
          },
          prefix: {
            name: this.$t("batches.prefix"),
            enabled: cols[4].enabled,
            sort: false,
          },
          profile: {
            name: this.$t("batches.profile"),
            enabled: cols[5].enabled,
            sort: false,
          },
          username_length: {
            name: this.$t("batches.username_length"),
            enabled: cols[6].enabled,
            sort: false,
          },
          password_length: {
            name: this.$t("batches.password_length"),
            enabled: cols[7].enabled,
            sort: false,
          },
          allowed_sessions: {
            name: this.$t("batches.sessions"),
            enabled: cols[8].enabled,
            sort: false,
          },
          is_mac: {
            name: this.$t("batches.is_mac"),
            enabled: cols[9] != null ? cols[9].enabled : false,
            sort: false,
          },
          created_at: {
            name: this.$t("batches.created_at"),
            enabled: cols[10] != null ? cols[10].enabled : false,
            sort: false,
          },
        };
      }
    },
    async applyFilters() {
      this.loading = true;
      var requestString = "cards?filters=1";
      if (this.filters.page != "")
        requestString += `&page=${this.filters.page}`;
      if (this.filters.rows != "")
        requestString += `&rows=${this.filters.rows}`;
      if (this.filters.name != "")
        requestString += `&name=${this.filters.name}`;
      if (this.filters.quantity != "")
        requestString += `&quantity=${this.filters.quantity}`;
      if (this.filters.price != "")
        requestString += `&price=${this.filters.price}`;
      if (this.filters.prefix != "")
        requestString += `&prefix=${this.filters.prefix}`;
      if (this.filters.profile != "")
        requestString += `&profile=${this.filters.profile}`;
      if (this.filters.username_length != "")
        requestString += `&username_length=${this.filters.username_length}`;
      if (this.filters.password_length != "")
        requestString += `&password_length=${this.filters.password_length}`;
      if (this.filters.allowed_sessions != "")
        requestString += `&allowed_sessions=${this.filters.allowed_sessions}`;
      if (this.filters.created_at != "")
        requestString += `&created_at=${this.filters.created_at}`;
      if (this.filters.search_query != null)
        requestString += `&search_query=${this.filters.search_query}`;
      if (this.sort_col)
        requestString += `&order_by=${this.sort_col}&order_dir=${this.sort_dir}`;
      const response = await axios.get(requestString);
      this.dataList = response.data.data;
      if (this.filters.save)
        localStorage.setItem("batches_filters", JSON.stringify(this.filters));
      if (this.dataList.length < 1 && this.filters.page != 1) {
        this.filters.page = 1;
        this.applyFilters();
      }
      if (this.sort_col) {
        if (this.sort_dir == "ASC") {
          this.dataList.sort((a, b) =>
            a[this.sort_col] > b[this.sort_col]
              ? 1
              : b[this.sort_col] > a[this.sort_col]
              ? -1
              : 0
          );
        } else {
          this.dataList.sort((a, b) =>
            a[this.sort_col] < b[this.sort_col]
              ? 1
              : b[this.sort_col] < a[this.sort_col]
              ? -1
              : 0
          );
        }
      }
      this.meta = response.data.meta;
      this.loading = false;
      // clearTimeout(this.debounce);
      // this.debounce = setTimeout(async () => {
      //   const response = await axios.get(requestString);
      //   this.dataList = response.data.data;
      //   if (this.filters.save)
      //     localStorage.setItem("batches_filters", JSON.stringify(this.filters));
      //   if (this.dataList.length < 1 && this.filters.page != 1) {
      //     this.filters.page = 1;
      //     this.applyFilters();
      //   }
      //   if (this.sort_col) {
      //     if (this.sort_dir == "ASC") {
      //       this.dataList.sort((a, b) =>
      //         a[this.sort_col] > b[this.sort_col]
      //           ? 1
      //           : b[this.sort_col] > a[this.sort_col]
      //           ? -1
      //           : 0
      //       );
      //     } else {
      //       this.dataList.sort((a, b) =>
      //         a[this.sort_col] < b[this.sort_col]
      //           ? 1
      //           : b[this.sort_col] < a[this.sort_col]
      //           ? -1
      //           : 0
      //       );
      //     }
      //   }
      //   this.meta = response.data.meta;
      //   this.loading = false;
      // }, 1000);
    },
    async fetchDataPortion(rows, currentPage) {
      this.filters.rows = rows;
      this.filters.page = currentPage;
      this.loading = true;
      var requestString = `cards?rows=${rows}&page=${currentPage}`;
      const response = await axios.get(requestString);
      this.dataList = response.data.data;
      this.meta = response.data.meta;
      this.loading = false;
    },
    showCopyDialog(card) {
      this.copyCard = card;
      var modalElement = document.getElementById("add-cards");
      var modalInstance = new bootstrap.Modal(modalElement);
      modalInstance.show();
    },
    async showAddBatchDialog(card = null, operation = "new") {
      this.showAddBatch = true;
      if (card) {
        this.copyCard = card;
      }
      await this.$nextTick();
      var modalElement = document.getElementById("add-cards");
      var modalInstance = new bootstrap.Modal(modalElement);
      modalElement.addEventListener("hide.bs.modal", (event) => {
        this.showAddBatch = false;
      });
      modalInstance.show();
    },
    editData(selectedData) {
      this.$router.push(`/cards/${selectedData.id}/edit`);
    },
    async showDeleteDialog(batch) {
      this.$swal({
        title: this.$t("batches.delete_batch_permanently") + " " + batch.name,
        text: this.$t(
          "batches.this_will_delete_batch_and_all_its_cards_permanently"
        ),
        icon: "question",
        showCancelButton: true,
        confirmButtonText: this.$t("accounts.yes_delete_it"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-danger",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.delete(`cards/${batch.id}`);
            if (response.status == 200) {
              this.selection_array = [];
              this.fetchData();
            }
            this.$swal({
              title: this.$t("control.success"),
              text: this.$t("batches.batch_has_been_permanently_delete"),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        }
      });
    },
    async openAddProfileDialog(profile = null) {
      this.showAddProfile = true;
      if (profile) {
        this.$router.push({
          query: { profile_id: profile.id },
        });
      }
      await this.$nextTick();
      var modalElement = document.getElementById("add-profile");
      var modalInstance = new bootstrap.Modal(modalElement);
      modalElement.addEventListener("hide.bs.modal", (event) => {
        this.showAddProfile = false;
        this.$router.push({ query: {} });
      });
      modalInstance.show();
    },
    formatDate(date) {
      return moment(date).format("yyyy-MM-DD HH:mm");
    },
    openContextMenu(e, data) {
      this.selectedData = data;
      this.$refs.menu.open(e);
    },
    checkAll() {
      if (this.allSelected) {
        this.selection_array = [];
        this.dataList.forEach((element) => {
          element.selected = false;
        });
        this.allSelected = false;
      } else {
        this.selection_array = [];
        this.dataList.forEach((element) => {
          element.selected = true;
          this.selection_array.push(element);
        });
        this.allSelected = true;
      }
    },
    selectData(data) {
      if (data.selected == false) {
        data.selected = true;
        this.selection_array.push(data);
      } else {
        data.selected = false;
        this.selection_array.splice(this.selection_array.indexOf(data), 1);
      }
    },
    updateColumns(updated) {
      localStorage.setItem(
        "batches_columns",
        JSON.stringify(Object.values(this.columns))
      );
    },
    async toggleAutoUpdate() {
      this.autoUpdate = !this.autoUpdate;
      while (this.autoUpdate) {
        this.applyFilters();
        await new Promise((r) => setTimeout(r, 30000));
      }
    },
    printCards() {
      this.$router.push(`/cards/${this.selectedData.id}/print`);
      this.$store.commit("changeKey");
    },
    sort(param) {
      this.sort_col = param;
      if (!this.columns[param].sort) {
        this.sort_dir = "ASC";
        Object.entries(this.columns).forEach(([key, val]) => {
          val.sort = false;
        });
        this.columns[param].sort = true;
      } else {
        this.sort_dir = "DESC";
        Object.entries(this.columns).forEach(([key, val]) => {
          val.sort = false;
        });
        this.columns[param].sort = false;
      }
      this.applyFilters();
    },
    exportCsv(id) {
      window.location.href =
        localStorage.getItem("server_api") + `export/${id}`;
    },
    toggleSaveFilters() {
      this.filters.save = !this.filters.save;
      localStorage.setItem("batches_filters", JSON.stringify(this.filters));
    },
    export_csv(table_id, file_name) {
      return export_csv(table_id, file_name);
    },
    export_pdf(table_id, file_name) {
      return export_pdf(table_id, file_name);
    },
    print_table(id) {
      print_table(id);
    },
  },
};
</script>
